// extracted by mini-css-extract-plugin
module.exports = {"tpLogoMenu":"home_tpLogoMenu__tG_ql","loginButtons":"home_loginButtons__1jT2B"};